module.exports = __webpack_public_path__ + "assets/img/dms_logo.c5397c79.png";